import React from "react";
import CheckoutSection from "./CheckoutSection";

const PaymentSection = ({ paymentMethod, onPaymentMethodChange }) => (
  <CheckoutSection title="03 / Payment">
    <div className="space-y-3" data-testid="payment-methods">
      <PayOption value="cod" current={paymentMethod} onChange={onPaymentMethodChange} title="Cash on Delivery" desc="Pay when it arrives. ₹0 extra fee." />
      <PayOption value="phonepe" current={paymentMethod} onChange={onPaymentMethodChange} title="PhonePe" desc="Secure hosted checkout for UPI, cards, wallet and net banking" />
    </div>
    <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.16em] text-zinc-600">
      PhonePe redirects to the official hosted payment page. Secret keys stay on the backend.
    </p>
  </CheckoutSection>
);

const PayOption = ({ value, current, onChange, title, desc }) => (
  <button
    type="button"
    onClick={() => onChange(value)}
    className={`w-full rounded-[10px] border px-4 py-4 text-left transition-all duration-200 ${
      current === value 
        ? "border-cynos-red bg-cynos-red/5" 
        : "border-white/10 hover:border-white/20 hover:bg-white/5"
    }`}
    data-testid={`pay-${value}`}
  >
    <div className="flex items-center justify-between gap-4">
      <div className="min-w-0 flex-1">
        <div className="font-semibold uppercase text-white">{title}</div>
        <div className="mt-1 text-xs text-zinc-500">{desc}</div>
      </div>
      <div className={`h-5 w-5 shrink-0 rounded border transition-colors ${current === value ? "border-cynos-red bg-cynos-red" : "border-white/30 bg-transparent"}`} />
    </div>
  </button>
);

export default PaymentSection;
